import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import OwnRing from '../../../Assets/images/cultured-img/landing-page-img/labgrown-bg.png'
import IconRing1 from '../../../Assets/images/cultured-img/landing-page-img/eng-icon1.png'
import IconRing2 from '../../../Assets/images/cultured-img/landing-page-img/eng-icon2.png'
import IconRing3 from '../../../Assets/images/cultured-img/landing-page-img/eng-icon3.png'
import { NavLink } from 'react-router-dom'

const OwnEngagmentRing = () => {
    return (
        <>
            <div className='dfld_own_engagment_ring_section'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row className='w-100 m-auto'>
                        <Col sm={12} md={6} lg={6} className="dfld_looss_img">
                            <div className='dfld_Own_Ring_img'>
                                <Image src={OwnRing} alt="Own Ring Images" className="img-fluid" />
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={6}>
                            <div className=''>
                                <div className="title-box4 text-center">
                                    <h2 className="dark play-font own-tit">Design your <span className="conf-spn">own</span> Engagement Ring</h2>
                                </div>
                                <p className="both-pr">
                                Select your preferred diamond shape and narrow down your options by factors such as carat, color, clarity, certificate or by budget. We are highly likely to have a wide selection of diamonds matching your specifications. So choose a loose diamond of your choice and match it with a beautiful ring setting in the precious metal of your choice. 
                                </p>
                                <div className="eng-btn pt-0">
                                    <ul>
                                        <li> <NavLink to="#"> <img src={IconRing1} alt="Ring" /> </NavLink> </li>
                                        <li>+ </li>
                                        <li> <NavLink to="#"> <img src={IconRing2} alt="Diamond" /> </NavLink> </li>
                                        <li>= </li>
                                        <li> <img src={IconRing3} alt="Complete Ring" /></li>
                                    </ul>
                                    <div className="btn-wrapper btn-wrapper2 row text-center eng-btn">
                                        <div className=" col-md-6 col-sm-12 col-lg-6 col-xs-12 "> <NavLink className="btn-engage text-uppercase" to="/diamonds"> LAB CREATED </NavLink> </div>
                                        <div className="col-md-6 col-sm-12 col-lg-6 col-xs-12"> <NavLink className="btn-engage mr-0 ml-0 text-uppercase" to="/ringsettings">Engagement Rings </NavLink> </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default OwnEngagmentRing